import React, {useState} from "react";
import styled from "styled-components";
import icon01 from '../../assets/images/nature-use-icon01.png';
import icon02 from '../../assets/images/nature-use-icon06.png';
import icon03 from '../../assets/images/nature-use-icon02.png';
import icon04 from '../../assets/images/nature-use-icon04.png';
import icon05 from '../../assets/images/nature-user-icon15.png';
import icon06 from '../../assets/images/nature-use-icon03.png';
import icon07 from '../../assets/images/nature-user-icon16.png';
import icon08 from '../../assets/images/nature-use-icon07.png';
import icon09 from '../../assets/images/nature-use-icon08.png';
import icon10 from '../../assets/images/nature-use-icon09.png';
import icon11 from '../../assets/images/nature-use-icon10.png';
import icon12 from '../../assets/images/nature-user-icon17.png';
import icon13 from '../../assets/images/nature-use-icon11.png';
import icon14 from '../../assets/images/nature-user-icon18.png';
import icon15 from '../../assets/images/nature-use-icon12.png';
import icon16 from '../../assets/images/nature-use-icon13.png';
import icon17 from '../../assets/images/nature-use-icon14.png';
import icon18 from '../../assets/images/nature-user-icon20.png';
import PageHeader from "../../components/organisms/PageHeader";
import SubTitle from "../../components/atoms/SubTitle";
import Btn from "../../components/atoms/Btn";
import Modal from "../../components/organisms/Modal";
import ShuttleBusModal from "../../components/templates/ShuttleBusModal";
import PricingTable from "../../components/molecules/PricingTable";
import map from "../../assets/images/map-bg.png";
import noticeInfo from "../../data/menu2/notiList.json";
import {device} from "../../assets/styles/media.js";
import Bullet from "../../components/atoms/Bullet";


const Contents = styled.div`
    margin-top: 60px;
    margin-bottom: 140px;

    ${device.mobile} {
        margin-top: 30px;
        margin-bottom: 50px;
    }
`;
const Section = styled.section`
    margin-bottom: 29px;
`;
const SimbolTarget = styled.div`
    padding-top: 100px;
    width: 1px;
    height: 1px;
    font-size: 0;
    line-height: 0;
    display: block;

    ${device.tablet} {
        padding-top: 30px;
    }

    ${device.mobile} {
        padding-top: 30px;
    }

`;
const MapBox = styled.div`
    width: 1200px;
    height: auto;
    margin: 0 auto;
    padding-bottom: 100px;
    ${device.tablet} {
        width: 100%;
        padding-bottom: 50px;
    }

    ${device.mobile} {
        width: 100%;
        padding-bottom: 50px;
    }
`;
const MapBg = styled.img`
    width: 100%;

`;

const NotifyList = styled.ul`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;

    ${device.pc} {
        gap: 20px;
    }

    ${device.tablet} {
        grid-template-columns: 1fr;
        place-items: flex-start;
    }

    ${device.mobile} {
        grid-template-columns: 1fr;
        place-items: flex-start;
    }
`;
const NotiItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #dedede;
    padding: 30px;
    margin-top: 20px;
    white-space: pre-wrap;


    ${device.pc} {
        flex-direction: column;
        justify-content: start;
        gap: 10px;
    }

    ${device.tablet} {
        justify-content: space-between;
        padding: 50px 30px;
        flex-direction: row;
        max-width: 600px;
    }

    ${device.mobile} {
        flex-direction: row;
        justify-content: space-between;
        padding: 15px;
        margin-top: 0;
        width: 100%;
        min-width: 320px;
        max-width: 400px;
        &:first-child {
            margin-top: 0;
        }
    }
`;
const NotiIcon = styled.span`
    display: inline-block;
    width: 90px;
    height: 90px;
    flex-shrink: 0;
    background-image: url(${(props) => props.icon});
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;

    ${device.tablet} {
        zoom: 1.2;
    }

    ${device.mobile} {
        width: 60px;
        height: 60px;
        margin-right: 10px;
    }
`;
const NotiText = styled.p`
    width: 70%;
    color: #4a4a4a;
    font-size: 15px;
    line-height: 26px;
    letter-spacing: -0.5px;
    box-sizing: border-box;

    ${device.pc} {
        width: 100%;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
    }

    ${device.tablet} {
        line-height: 35px;
        letter-spacing: -0.5px;
        text-align: left;
        font-size: 17px;
        white-space: initial;

        span {
            font-size: 17px;
        }
    }

    ${device.mobile} {
        font-size: 13px;
        line-height: 20px;
        text-align: left;
        white-space: pre;
        letter-spacing: -0.8px;
        span {
            letter-spacing: -0.8px;
            font-size: 12px;
        }
    }
`;

const Desc = styled.span`
    color: #ed8e0c;
    display: block;
`;


const List = styled.ul`
    li:first-child {
        margin: 20px 0 0 12px;
        line-height: 27px;
    }
`;

const NoticeList = styled.ul`
    margin-top: 20px;
    white-space: pre-wrap;

    ${device.mobile} {
        padding: 0 10px;
    }
`;
const NoticeItem = styled.li`
    margin: 6px 0;
    display: block;
    white-space: pre-wrap;
    position: relative;
    padding-left: 10px;
    color: #919191;
    font-size: 18px;
    letter-spacing: -0.55px;
    line-height: 30px;

    ${device.mobile} {
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
    }
`;
const Item = styled.li`
    padding-bottom: 8px;
    padding-left: 12px;
    white-space: pre-wrap;
    color: #414141;
    margin: 8px 0 0 12px;
    line-height: 27px;
`;

const NaturePoolGuide = () => {
    const [openModal, setOpenModal] = useState(false);
    const navList = [
        {id: 0, name: "운영시간&요금안내", link: "#"},
        {id: 1, name: "이용시 유의사항", link: "#caution"},
        {id: 2, name: "주차 및 셔틀버스 안내", link: "#shuttle"},
    ];
    const noticeList = [
        {
            icon: icon01,
            text: '안전하고 쾌적한 물놀이를 위해\n입수 전 샤워 후 수영장을 이용해 주세요.\n- 반려인: 간단한 샤워 \n- 반려견: 배변(강아지 화장실)및 간단한 샤워'
        },
        {
            icon: icon02,
            text: '안전한 물놀이를 위해 \n입수 전 간단한 준비운동은 필수입니다.'
        },
        {
            icon: icon03,
            text: '구명조끼(반려견, 어린이)\n아쿠아 슈즈를 반드시 착용해 주세요.'
        },
        {
            icon: icon04,
            text: '네이처풀 내 전 구역에서 13세 미만\n어린이와 반려견은 성인 보호자와 함께 \n이용하여야 하며, 영/유아(4세 미만)\n이용 시 반드시 방수 기저귀를\n착용해야 합니다.'
        },
        {
            icon: icon05,
            text: "바닥이 미끄러우니 조심히 이용해 주세요."
        },
        {
            icon: icon06,
            text: '안전을 위해 뛰거나 다이빙을 하는 행위는\n금지합니다.',
            desc: '(일부 구간 제외)'
        },
        {
            icon: icon07,
            text: "반려견이 낯선 공간에 적응할 수 있도록\n수영장 인근을 함께 산책하며 냄새를\n먼저 맡게 해주세요."
        },
        {
            icon: icon08,
            text: "반려견의 배변 수거는 보호자가\n직접 해야합니다."
        },
        {
            icon: icon09,
            text: "반려견이 물 속에서 배변을 할 경우,\n수영장의 물을 모두 빼고 청소를\n해야 함으로 이에 따른 비용을 \n청구할 수 있습니다."
        },
        {
            icon: icon10,
            text: "수영장 외 전구역은 온리쉬 구역으로,\n반드시 반려견에게 산책줄을 착용시켜 주세요."
        },
        {
            icon: icon11,
            text: "반려견이 사람이 먹는 음식에\n접근할 수 없도록 주의해 주세요."
        },
        {
            icon: icon12,
            text: "예약한 대여시설\n(방갈로, 썬베드, 파라솔)만 이용 가능합니다."
        },
        {
            icon: icon13,
            text: "귀중품은 개인 락커룸에 보관하여야 하며,\n분실 시 책임지지 않습니다."
        },
        {
            icon: icon14,
            text: "라커밴드는 지정된 곳에 반납해 주세요.\n분실 시 이에 따른 비용이 청구될 수 있습니다."
        },
        {
            icon: icon15,
            text: "고객 부주의로 인한 안전사고 발생 시\n본인 및 보호자의 책임이며, 강아지숲에\n일체의 책임을 물을 수 없습니다."
        },
        {
            icon: icon16,
            text: "네이처풀 전구역은 금연 구역입니다."
        },
        {
            icon: icon17,
            text: "필요 시 안전관리자의 통제 및 지시에\n따라주셔야 하며 불이행하거나 흡연, 고성 등\n다른 이용객에게 불쾌감을 주는 행위를 할 경우,\n퇴장 조치될 수 있습니다."
        },
        {
            icon: icon18,
            text: "비반려인의 경우,\n네이처풀 이용이 제한됩니다."
        },
    ];

    const infoList = [
        "사전 온라인 예매 후 입장이 가능하며, 남는 수량에 한하여 당일 현장 발권이 진행됩니다.",
        "유아(36개월 이하)는 무료 입장이 가능합니다."
    ];
    return (
        <>
            <PageHeader
                bTitle="관람"
                subTitle="네이처풀"
                detail="이용안내"
                desc="강아지숲 네이처풀 이용 안내해 드립니다."
                list={navList}
                link={true}
            />
            <Contents>
                {/*운영시간&요금안내*/}
                <Section>
                    <SubTitle text={"운영시간&요금안내"}/>
                    <PricingTable subTitle="운영시간&요금안내"/>
                    <List>
                        {infoList.map((item, index) => (
                            <Item key={index}>
                                <Bullet>{item}</Bullet>
                            </Item>
                        ))}
                    </List>
                </Section>
                <SimbolTarget id="caution"/>

                {/*이용시 유의사항*/}
                <Section>
                    <SubTitle text={"이용시 유의사항"}/>
                    <NotifyList>
                        {noticeList.map((item, index) => (
                            <NotiItem key={index}>
                                <NotiIcon icon={item.icon}/>
                                <NotiText>{item.text}
                                    <Desc>{item.desc}</Desc>
                                </NotiText>
                            </NotiItem>

                        ))}
                    </NotifyList>
                    <NoticeList>
                        {noticeInfo.map((info, index) =>
                            info.type === 'bullet' ? (
                                <Bullet key={index}>{info.text}</Bullet>
                            ) : (
                                <NoticeItem key={index}>{info.text}</NoticeItem>
                            )
                        )}
                    </NoticeList>
                </Section>

                <SimbolTarget id="shuttle"/>
                {/* 주차 및 셔틀버스 */}
                <Section>
                    <SubTitle text="주차 및 셔틀버스"/>
                    <MapBox>
                        <MapBg src={map}/>
                    </MapBox>
                    <Bullet>네이처풀 이용 시, 박물관동 앞 주차장에 주차하신 후 셔틀버스 이동을 부탁드립니다. 안전상의 이유로 네이처풀 내 주차장은 이용이 불가합니다.</Bullet>
                </Section>
                <Btn
                    text={"셔틀버스 운영 시간표"}
                    onClick={() => setOpenModal(true)}
                />
            </Contents>
            {openModal &&
                <Modal
                    title={"무료 셔틀 운행"}
                    open={openModal}
                    setOpenModal={setOpenModal}
                    content={<ShuttleBusModal/>}
                />
            }
        </>
    );
};

export default NaturePoolGuide;
